export const dollarsToRefundCents = dollars => {
  const parsed = parseFloat(dollars)
  if (isNaN(parsed) || parsed <= 0) return 0
  return Math.round(parsed * 100)
}

export const refundFormState = (amount, maxRefundCents, confirmed) => {
  const amountCents = dollarsToRefundCents(amount)
  const hasAmount = amountCents > 0
  const exceedsMax = hasAmount && amountCents > maxRefundCents
  const canSubmit = confirmed && hasAmount && !exceedsMax
  return { amountCents, hasAmount, exceedsMax, canSubmit }
}

// The API sends max_refundable_amount (charged minus refunded minus the
// non-refundable Uber Direct fee). Older payloads only carry charged_amount.
export const maxRefundCentsFor = (payment, checkout) => {
  const serverMax = payment?.attributes?.max_refundable_amount?.cents
  if (typeof serverMax === 'number') return Math.max(serverMax, 0)
  const charged = payment?.attributes?.charged_amount?.cents ?? 0
  const refunded = checkout?.attributes?.refunded_amount?.cents ?? 0
  return Math.max(charged - refunded, 0)
}
